module.exports = __webpack_public_path__ + "img/JarmuvekEmptyState.a21d6d0b.svg";